import React, { useEffect } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../lib/auth";

export default function ProtectedRoute({ children }) {
  const { user, load } = useAuth();
  const location = useLocation();

  // Re-verify user on every route change so must_rotate_password can never be stale.
  useEffect(() => { if (user) load(); /* eslint-disable-next-line */ }, [location.pathname]);

  if (user === null) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-erf-cream">
        <div className="font-mono text-xs text-erf-dark/60">Authenticating…</div>
      </div>
    );
  }
  if (user === false) return <Navigate to="/login" replace />;
  if (user && user.must_rotate_password) return <Navigate to="/auth/rotate" replace />;
  return children;
}
